export default __webpack_public_path__ + "static/1412-ec202932732063ea24a1fb5d0475b012.gif";